import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import usePageTitle from "@/hooks/use-page-title";

const COLORS = { draft: "#71717A", sent: "#0EA5E9", approved: "#22C55E", rejected: "#EF4444", converted: "#FF6B00" };

export default function CustomerQuotations() {
  usePageTitle("My Quotations");
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/quotations").then((r) => setRows(r.data)); }, []);
  return (
    <div className="space-y-6" data-testid="my-quotations-root">
      <div className="border-b border-[hsl(var(--border))] pb-6">
        <div className="overline mb-2">Customer</div>
        <h1 className="font-display text-4xl font-black tracking-tighter">My Quotations</h1>
      </div>
      <div className="card-swiss overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-[hsl(var(--border))]">
              <th className="px-4 py-3 text-left overline">Quote #</th>
              <th className="px-4 py-3 text-left overline">Date</th>
              <th className="px-4 py-3 text-right overline">Amount</th>
              <th className="px-4 py-3 text-left overline">Status</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-b border-[hsl(var(--border))] hover:bg-[hsl(var(--muted))]" data-testid={`my-quote-${r.id}`}>
                <td className="px-4 py-3"><Link to={`/quotations/${r.id}`} className="font-mono text-xs font-semibold hover:text-[#FF6B00]">{r.id}</Link></td>
                <td className="px-4 py-3 text-xs font-mono text-muted-foreground">{r.quote_date}</td>
                <td className="px-4 py-3 text-right font-mono">₹{Math.round(r.grand_total || 0).toLocaleString("en-IN")}</td>
                <td className="px-4 py-3">
                  <span className="inline-flex items-center border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider"
                    style={{ borderColor: COLORS[r.status], color: COLORS[r.status] }}>{r.status}</span>
                </td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr><td colSpan={4} className="py-12 text-center text-muted-foreground">No quotations shared yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
